module.exports = "/images/onward.png?c6bffd96094c9f303ac90d5e44e145cc";